import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const LoanFileCopyNumber = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <path d="M18 3H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2ZM8.5 5h8c.275 0 .5.225.5.5s-.225.5-.5.5h-8c-.275 0-.5-.225-.5-.5s.225-.5.5-.5ZM19 19c0 .551-.449 1-1 1H7c-.551 0-1-.449-1-1V8h13v11Z" />
    <path d="M8.5 15a.5.5 0 1 0 0 1h.908l-.389 1.362a.5.5 0 0 0 .962.276L10.449 16h2.96l-.39 1.362a.5.5 0 0 0 .962.276L14.449 16H16.5a.5.5 0 1 0 0-1h-1.765l.57-2H16.5a.5.5 0 1 0 0-1h-.908l.389-1.363a.5.5 0 0 0-.962-.274L14.551 12h-2.96l.39-1.363a.5.5 0 0 0-.962-.274L10.551 12H8.5a.5.5 0 1 0 0 1h1.766l-.572 2H8.5Zm2.806-2h2.96l-.572 2h-2.96l.572-2Z" />
  </SvgIcon>
);

export default LoanFileCopyNumber;
